import React,{useState} from 'react';
import {
    Collapse,Navbar,NavbarToggler,NavbarBrand,Nav,
    UncontrolledDropdown,DropdownToggle,
    DropdownMenu,DropdownItem,NavbarText,
    } from 'reactstrap';
import logo from '../../../assets/images/logo.png';
import {ADMIN_PROFILE_PATH} from '../../../utils/AppRoutes';
import { Link, useHistory } from 'react-router-dom';
import defaultAvatar from '../../../assets/images/defaultImages/defaultAvatar.png';
import { logout } from '../../../utils/functions/CoreFunctions';
import { getConfirm, getCurrentUserName, getCurrentProfile } from '../../../utils/functions/CustomFunctions';
import Swal from 'sweetalert2';

const AdminHeader = (props) => {
    const [isOpen, setIsOpen] = useState(false);
    const toggle = () => setIsOpen(!isOpen);
    const history = useHistory();

    const logoutClick = () => {
        Swal.fire(
           getConfirm('warning', 'Are you sure you want to sign out?')
        )
        .then(result => 
        {
            if (result.isConfirmed) {
                logout(history);
            }
        });  
    }


    return (
        <Navbar fixed='top' color='light' light expand='md' className='navbar-bg'>
            <NavbarBrand href='/'><img src={logo} alt="PayForm logo" /></NavbarBrand>
            <NavbarToggler onClick={toggle} />
            <Collapse isOpen={isOpen} navbar>
                <Nav className='me-auto' navbar></Nav>
                <NavbarText>
                    <UncontrolledDropdown nav inNavbar className='nav-dropdown'>
                        <DropdownToggle nav caret>
                            <img className='UserImg' src={getCurrentProfile() || defaultAvatar} alt="User profile" />
                            {/* <span>Natosha Jacobs</span> */}
                        </DropdownToggle>
                        <DropdownMenu end>
                            <DropdownItem>
                                <img className='dropdown-userImg' src={getCurrentProfile() || defaultAvatar} alt="User profile" />
                                <h6 className='text-center'>{getCurrentUserName()}</h6>
                                <p className='text-center'>Paygov Admin</p>
                            </DropdownItem>
                            <Link to={ADMIN_PROFILE_PATH} className="link">
                            <DropdownItem style={{cursor:'pointer'}}>
                                    My Profile 
                            </DropdownItem>
                            </Link>
                            <DropdownItem />                         
                            <DropdownItem onClick={logoutClick} style={{cursor:'pointer'}}>
                                     Sign Out
                            </DropdownItem>
                        </DropdownMenu>
                    </UncontrolledDropdown>
                </NavbarText>
            </Collapse>
        </Navbar>
    );
}
export default AdminHeader;
